import { IButtonStyles, ILinkStyles, IStackStyles, ITextStyles, ITheme } from '@fluentui/react';
import { color, IThemedProp } from './themesUI';

export interface IUpsellButtonStyles {
    isDefault?: boolean;
}

export const getUpsellButtonStyles = (props: IThemedProp & IUpsellButtonStyles): IButtonStyles => {
    const { theme, isDefault } = props;
    return {
        root: {
            backgroundColor: !isDefault ? theme.palette.themePrimary : theme.palette.white,
            borderColor: !isDefault ? theme.palette.themeTertiary : color.gray,
            color: !isDefault ? theme.palette.white : theme.palette.neutralPrimary,
            borderRadius: '4px',
            padding: '6px 12px',
            margin: '15px 0',
            marginLeft: isDefault && '15px',
            fontFamily: 'inherit',
        },
        rootHovered: {
            backgroundColor: !isDefault ? theme.palette.themeDarkAlt : '#c8c8c8',
            borderColor: !isDefault ? theme.palette.themeDark : color.gray,
        },
        rootFocused: {
            backgroundColor: !isDefault ? theme.palette.themeDark : '#c8c8c8',
            borderColor: !isDefault ? theme.palette.blueDark : color.gray,
            outline: '5px auto -webkit-focus-ring-color',
            outlineOffset: '-2px',
            textDecoration: 'none',
        },
        rootPressed: {
            backgroundColor: !isDefault ? theme.palette.themeDark : '#c8c8c8',
            borderColor: !isDefault ? theme.palette.blueDark : color.gray,
            outline: '5px auto -webkit-focus-ring-color',
            outlineOffset: '-2px',
            textDecoration: 'none',
        },
        label: {
            fontWeight: '400',
            fontSize: '14px',
        },
    };
};

export const getChatModalityButtonStyles = (props: { theme: ITheme, withBorderRadius?: boolean }): IButtonStyles => {
    const { theme } = props;
    return {
        root: {
            borderColor: `${theme.palette.themeTertiary} !important`,
            borderRadius: props.withBorderRadius ? '4px' : '0px',
            padding: '16px 12px',
            margin: '15px 0',
            verticalAlign: 'middle',
            fontFamily: 'inherit',
        },
        rootHovered: {
            borderColor: theme.palette.themeDark,
        },
        rootFocused: {
            backgroundColor: theme.palette.themeDark,
            borderColor: theme.palette.blueDark,
            outline: '5px auto -webkit-focus-ring-color',
            outlineOffset: '-2px',
            textDecoration: 'none',
        },
        rootPressed: {
            borderColor: theme.palette.blueDark,
            outline: '5px auto -webkit-focus-ring-color',
            outlineOffset: '-2px',
            textDecoration: 'none',
        },
        label: {
            fontWeight: '400',
            fontSize: '14px',
        },
    };
};

export const modalitySectionTitleStyles: ITextStyles = {
  root: { fontWeight: '600', fontSize: '14px', lineHeight: '20px' },
};

export const getModalitySectionBoxStyle = (noIconMargin?: boolean): IStackStyles => ({
  root: {
    border: '1px solid #D2D0CE',
    borderRadius: '4px',
    paddingTop: '14px',
    paddingBottom: '14px',
    paddingRight: '23px',
    paddingLeft: noIconMargin ? '64px' : '23px',
    verticalAlign: 'middle',
  },
});

export const getModalityIconStyle = (color: string): IStackStyles => ({
  root: { fontSize: '18px', marginBottom: 'auto', marginTop: 'auto', color: color },
});

export const getModalityLinkStyle = (textColor: string): ILinkStyles => ({
  root: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: textColor,
    selectors: {
      '&:hover, &:focus': {
        cursor: 'pointer',
        color: textColor,
      },
    },
  },
});

export const modalityDescriptionStyle: ILinkStyles = {
  root: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
  },
};

export const upSellTitleStyle: IStackStyles = {
  root: {
    fontWeight: 600,
    fontSize: '14px',
    marginBottom: '2px',
  },
};

export const getUpSellDescriptionStyle = (color: string): IStackStyles => ({
  root: {
    color: color,
  },
});

export const getOpenItNowLinkStyle = (textColor: string): ILinkStyles => ({
  root: {
    padding: '0px 0px 0px 7px',
    fontSize: '14px',
    color: `${textColor} !important`,
    selectors: {
      '&:hover, &:focus': {
        cursor: 'pointer',
        color: `${textColor} !important`,
      },
    },
  },
});

export const requestConfirmationFooterText: ITextStyles = { root: { display: 'block', marginTop: '30px' } };
